import React from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/PrimaryButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { TextInputField } from '../../../components/FormCom/FormField';
import { ModalContentWrapper } from '../../../components/Modal/ModalContentWrapper';
import useUpdatePrice from '../../../hooks/warehouse/useUpdatePrice';
import {
  UpdatePriceDataType,
  UpdatePriceInitialValues,
  UpdatePriceSchema,
} from '../../../models/warehouse/updatePrice.model';

interface IUpdatePriceModal {
  priceId: string;
}

const UpdatePriceModal: React.FC<IUpdatePriceModal> = ({ priceId }) => {
  const { updatePrice, loading } = useUpdatePrice();

  const onSubmit = (values: UpdatePriceDataType, actions: any) => {
    updatePrice({ priceId: priceId, price: values.price });

    // if (resetInputFields) {
    actions.resetForm(UpdatePriceInitialValues);
    // }
  };

  return (
    <ModalContentWrapper title={'Update Price'} width={'28rem'}>
      <Container>
        <FormComponent
          initialValues={UpdatePriceInitialValues}
          schema={UpdatePriceSchema}
          onSubmit={onSubmit}
        >
          <TextInputField
            label="Enter Price"
            name="price"
            type="text"
            placeholder="Price"
            className="full"
          />

          <FormSubmitButton
            type="submit"
            showIcon={loading}
            className="placeLeft"
          >
            Update Price
          </FormSubmitButton>
        </FormComponent>
      </Container>
    </ModalContentWrapper>
  );
};

export default UpdatePriceModal;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
